import { IResource } from "@gettactic/api";
import { ResourceTypes } from "@gettactic/helpers/src/resources/utils";
import { Users } from "lucide-react";

export const CapacityLabel = ({
  resource,
  prefix = <span className="shrink-0">·</span>
}: {
  resource: IResource | Partial<IResource> | null | undefined;
  prefix?: React.ReactNode;
}) => {
  if (!resource || (resource.available_slots ?? 0) < 1) return null;
  const isMeetingRoom = resource.type === ResourceTypes.meeting_room;
  const isWorkspace =
    resource.type === ResourceTypes.workspace ||
    resource.type === ResourceTypes.desk;
  const isSingleSlot = resource.total_slots === 1;
  const isGroupWorkspace = isWorkspace && !isSingleSlot;
  if (isMeetingRoom || isGroupWorkspace) {
    return (
      <span className="flex items-center gap-1 px-0.5 font-medium text-muted-foreground text-xs">
        {prefix}
        {/* LUCIDE ICONS TWO USERS ICON */}
        <Users className="h-4 w-4" />
        {resource.total_slots}
      </span>
    );
  }
  return null;
};
